import type { JobOutcomeType } from '@/features/jobs/types/job-detail'
import type { JobSeverity, JobStatus, JobType } from '@/features/jobs/types/job'

export type JobTypeFilter = JobType

export type JobStatusFilter = JobStatus

export type JobOutcomeFilter = JobOutcomeType

export type JobFilters = {
  date_raised: string
  job_type?: JobTypeFilter
  location: string
  raised_by_user_id?: number
  assigned_partner_id?: number
  status?: JobStatusFilter
  severity?: JobSeverity
  outcome?: JobOutcomeFilter
  completed_at: string
  completed_by_user_id?: number
}

export const emptyJobFilters = (): JobFilters => ({
  date_raised: '',
  job_type: undefined,
  location: '',
  raised_by_user_id: undefined,
  assigned_partner_id: undefined,
  status: undefined,
  severity: undefined,
  outcome: undefined,
  completed_at: '',
  completed_by_user_id: undefined,
})
